<template>
  <div :class="classes">
    <m4-input
      v-bind="$attrs"
      v-model="computedValue"
      type="text"
      inputmode="numeric"
      autocomplete="off"
      :mask="inputMask"
      ref="numericField"
    ></m4-input>
    <div class="numeric-field__actions">
      <m4-button @click="increase" type="button" variant="default-text" class="numeric-field__actions__up">
        <m4-icon icon="angle-up"></m4-icon>
      </m4-button>
      <m4-button @click="decrease" type="button" variant="default-text" class="numeric-field__actions__down">
        <m4-icon icon="angle-down"></m4-icon>
      </m4-button>
    </div>
  </div>
</template>

<script>
import callExternalFunction from "../../../utils/callExternalFunction";

export default {
  name: "M4NumericField",
  mixins: [callExternalFunction],
  data() {
    return {
      newValue: this.modelValue ? this.modelValue : this.value
    };
  },
  props: {
    value: {
      type: [String, Number]
    },
    modelValue: {
      type: [String, Number]
    },
    minValue: {
      type: Number,
      default: 1
    },
    maxValue: {
      type: Number,
      default: 9999
    },
    maxDigit: {
      type: Number,
      default: 4
    },
    allowDecimal: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  computed: {
    classes() {
      let classes = ["numeric-field"];
      return classes;
    },
    inputMask() {
      if (this.minValue < 0) {
        return {
          mask: "[-]9{1," + this.maxDigit + "}" + (this.allowDecimal ? "[.*{1,2}]" : "")
        };
      }
      return {
        mask: "9{1," + this.maxDigit + "}" + (this.allowDecimal ? "[.*{1,2}]" : "")
      };
    },
    computedValue: {
      get() {
        return this.newValue;
      },
      set(value) {
        this.newValue = value;
        this.$emit("update:modelValue", value);
        this.callExtFunc("updateModelValue", value);
      }
    }
  },
  methods: {
    increase() {
      if (this.$attrs.disabled) {
        return false;
      }

      this.$refs.numericField.$refs.inputElm.focus();
      if (!this.newValue) {
        this.newValue = 0;
      }
      if (this.newValue < this.maxValue) {
        this.newValue++;
      }
      this.$emit("update:modelValue", this.newValue);
      this.callExtFunc("updateModelValue", this.newValue);
    },
    decrease() {
      if (this.$attrs.disabled) {
        return false;
      }

      this.$refs.numericField.$refs.inputElm.focus();
      if (!this.newValue) {
        this.newValue = 0;
      }
      if (this.newValue === 0) {
        this.newValue = this.minValue > 0 ? this.minValue : this.newValue - 1;
      } else if (this.newValue > this.minValue) {
        this.newValue--;
      }
      this.$emit("update:modelValue", this.newValue);
      this.callExtFunc("updateModelValue", this.newValue);
    },
    getNewValue() {
      return this.newValue;
    },
    setNewValue(val) {
      this.newValue = val;
    }
  },
  watch: {
    modelValue(value) {
      this.newValue = value;
    },
    value(value) {
      this.newValue = value;
    }
  }
};
</script>
